// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as KoRouteImport } from './routes/ko'
import { Route as AppBaggersRouteImport } from './routes/_app.baggers'
import { Route as AppLearnRouteImport } from './routes/_app.learn'
import { Route as AppPortfolioRouteImport } from './routes/_app.portfolio'
import { Route as AppReferralsRouteImport } from './routes/_app.referrals'
import { Route as AppSignRouteImport } from './routes/_app.sign'
import { Route as AppTermsRouteImport } from './routes/_app.terms'
import { Route as KoIndexRouteImport } from './routes/ko.index'
import { Route as KoAppRouteImport } from './routes/ko._app'
import { Route as RCodeRouteImport } from './routes/r.$code'
import { Route as AppLearnIndexRouteImport } from './routes/_app.learn.index'
import { Route as AppLearnSlugRouteImport } from './routes/_app.learn.$slug'
import { Route as AppTradeIndexRouteImport } from './routes/_app.trade.index'
import { Route as AppTradeSymbolRouteImport } from './routes/_app.trade.$symbol'
import { Route as KoAppLearnRouteImport } from './routes/ko._app.learn'
import { Route as KoAppLearnIndexRouteImport } from './routes/ko._app.learn.index'
import { Route as KoAppLearnSlugRouteImport } from './routes/ko._app.learn.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const KoRoute = KoRouteImport.update({
            id: '/ko',path: '/ko',getParentRoute: () => rootRouteImport
          })
const AppBaggersRoute = AppBaggersRouteImport.update({
            id: '/baggers',path: '/baggers',getParentRoute: () => AppRoute
          })
const AppLearnRoute = AppLearnRouteImport.update({
            id: '/learn',path: '/learn',getParentRoute: () => AppRoute
          })
const AppPortfolioRoute = AppPortfolioRouteImport.update({
            id: '/portfolio',path: '/portfolio',getParentRoute: () => AppRoute
          })
const AppReferralsRoute = AppReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => AppRoute
          })
const AppSignRoute = AppSignRouteImport.update({
            id: '/sign',path: '/sign',getParentRoute: () => AppRoute
          })
const AppTermsRoute = AppTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => AppRoute
          })
const KoIndexRoute = KoIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => KoRoute
          })
const KoAppRoute = KoAppRouteImport.update({
            id: '/_app',getParentRoute: () => KoRoute
          })
const RCodeRoute = RCodeRouteImport.update({
            id: '/r/$code',path: '/r/$code',getParentRoute: () => rootRouteImport
          })
const AppLearnIndexRoute = AppLearnIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppLearnRoute
          })
const AppLearnSlugRoute = AppLearnSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => AppLearnRoute
          })
const AppTradeIndexRoute = AppTradeIndexRouteImport.update({
            id: '/trade/',path: '/trade/',getParentRoute: () => AppRoute
          })
const AppTradeSymbolRoute = AppTradeSymbolRouteImport.update({
            id: '/trade/$symbol',path: '/trade/$symbol',getParentRoute: () => AppRoute
          })
const KoAppLearnRoute = KoAppLearnRouteImport.update({
            id: '/learn',path: '/learn',getParentRoute: () => KoAppRoute
          })
const KoAppLearnIndexRoute = KoAppLearnIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => KoAppLearnRoute
          })
const KoAppLearnSlugRoute = KoAppLearnSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => KoAppLearnRoute
          })





const AppLearnRouteChildren = {
  AppLearnSlugRoute: AppLearnSlugRoute,AppLearnIndexRoute: AppLearnIndexRoute
}

const AppLearnRouteWithChildren = AppLearnRoute._addFileChildren(AppLearnRouteChildren)



const AppRouteChildren = {
  AppBaggersRoute: AppBaggersRoute,AppLearnRoute: AppLearnRouteWithChildren,AppPortfolioRoute: AppPortfolioRoute,AppReferralsRoute: AppReferralsRoute,AppSignRoute: AppSignRoute,AppTermsRoute: AppTermsRoute,AppTradeSymbolRoute: AppTradeSymbolRoute,AppTradeIndexRoute: AppTradeIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)




const KoAppLearnRouteChildren = {
  KoAppLearnSlugRoute: KoAppLearnSlugRoute,KoAppLearnIndexRoute: KoAppLearnIndexRoute
}

const KoAppLearnRouteWithChildren = KoAppLearnRoute._addFileChildren(KoAppLearnRouteChildren)



const KoAppRouteChildren = {
  KoAppLearnRoute: KoAppLearnRouteWithChildren
}

const KoAppRouteWithChildren = KoAppRoute._addFileChildren(KoAppRouteChildren)



const KoRouteChildren = {
  KoAppRoute: KoAppRouteWithChildren,KoIndexRoute: KoIndexRoute
}

const KoRouteWithChildren = KoRoute._addFileChildren(KoRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,KoRoute: KoRouteWithChildren,RCodeRoute: RCodeRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)